import { useState } from 'react';
import { Modal, Button } from '../../../components/ui';
import { useSaveResultComment, useDeleteResultComment } from '../../../api/hooks';
import type { ResultComment } from '../../../api/types';

const MAX = 1000;

export default function ResultCommentModal({ examId, studentId, studentName, comment, onClose }: {
  examId: number; studentId: number; studentName: string; comment: ResultComment | null; onClose: () => void;
}) {
  const [text, setText] = useState(comment?.body ?? '');
  const [error, setError] = useState('');
  const save = useSaveResultComment(examId);
  const del = useDeleteResultComment(examId);
  const busy = save.isPending || del.isPending;

  const fail = (e: any) => {
    const d = e?.response?.data;
    setError(d?.body ?? d?.detail ?? 'Could not save the comment. Try again.');
  };
  const onSave = () => {
    setError('');
    save.mutate({ studentId, body: text }, { onSuccess: onClose, onError: fail });
  };
  const onDelete = () => {
    setError('');
    del.mutate(studentId, { onSuccess: onClose, onError: fail });
  };

  return (
    <Modal isOpen onClose={onClose} title={`Comment for ${studentName}`}
      footer={
        <div className="flex w-full flex-wrap justify-end gap-2">
          {comment && <Button variant="danger" disabled={busy} onClick={onDelete}>Delete</Button>}
          <Button variant="ghost" disabled={busy} onClick={onClose}>Cancel</Button>
          <Button disabled={busy || !text.trim()} loading={save.isPending} onClick={onSave}>Save</Button>
        </div>
      }>
      <textarea aria-label="Comment" rows={5} maxLength={MAX} value={text}
        className="w-full rounded-lg border border-stroke bg-transparent px-3 py-2 text-sm text-black outline-none focus:border-primary dark:border-strokedark dark:bg-meta-4 dark:text-white"
        onChange={(e) => setText(e.target.value)} />
      <div className="mt-1 text-right text-xs text-bodydark2">{text.length} / {MAX}</div>
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </Modal>
  );
}
